import Overlay from "ol/Overlay";
import { getCenter } from "ol/extent";
import $ from 'jquery';
import moment from "moment";
export class Popup {
    constructor(feature, map) {
        this.map = map;
        this.calculate_positioning = (center) => {
            const pixelCenter = this.map.getPixelFromCoordinate(center);
            if (!pixelCenter)
                return "top-left";
            let box_width = 200;
            let box_height = 180;
            let map_width = this.map.getSize() ? this.map.getSize()[0] : 0;
            let map_height = this.map.getSize() ? this.map.getSize()[1] : 0;
            let r_box_width = box_width + pixelCenter[0];
            let r_box_height = box_height + pixelCenter[1];
            if (r_box_width >= map_width && r_box_height >= map_height) {
                return "bottom-right";
            }
            else if (r_box_height >= map_height) {
                return "bottom-left";
            }
            else if (r_box_width >= map_width) {
                return "top-right";
            }
            else {
                return "top-left";
            }
        };
        this.feature = feature;
    }
    addOrUpdateOverlay(data) {
        var strap = this.getStrap(data);
        const existingTooltip = $(`#tooltip-${strap}`);
        if (existingTooltip.length > 0) {
            $(".overlay-popover").removeClass('tooltip-active');
            $(`.ol-${strap}`).addClass('tooltip-active');
            return;
        }
        const geometry = this.feature.getGeometry();
        const extent = geometry.getExtent();
        const center = getCenter(extent);
        let tooltipElement = this.createOrUpdateTooltip(data);
        let overlay = new Overlay({
            element: tooltipElement.get(0),
            position: center,
            positioning: this.calculate_positioning(center),
            stopEvent: false,
            className: `ol-${strap} overlay-popover`,
            offset: [0, -10],
        });
        this.map.addOverlay(overlay);
        $(".overlay-popover").removeClass('tooltip-active');
        $(`.ol-${strap}`).addClass('tooltip-active');
        tooltipElement.on('click', () => {
            $(".overlay-popover").removeClass('tooltip-active');
            $(`.ol-${strap}`).addClass('tooltip-active');
        });
    }
    createOrUpdateTooltip(data) {
        var strap = this.getStrap(data);
        let tooltipElement = $(`#tooltip-${strap}`);
        if (tooltipElement.length === 0) {
            tooltipElement = this.createPopupElement(data);
        }
        return tooltipElement;
    }
    createPopupElement(data) {
        const strap = this.getStrap(data);
        const tooltipElement = $('<div>').attr('id', `tooltip-${strap}`).addClass('popup');
        const labelContent = $('<div>', { id: 'label-content' });
        const border = $('<div>', { id: 'border' });
        const labelInfo = $('<div>', { id: 'label-info' });
        const pinButton = $(`<button id="pin-button-${strap}" class="pin-button"><i class="fas fa-thumbtack fa-xs" title="Pin"></i></button>`);
        border.append(pinButton);
        labelContent.append(border);
        const heading = $(`<div id="heading"><strong>Detail of: ${strap}</strong></div>`);
        labelInfo.append(heading);
        const columns = Object.keys(data);
        columns.forEach((key) => {
            let value = data[key];
            const isUrl = typeof value === 'string' && value.startsWith('http');
            const anchorTag = isUrl ? `<a href="${value}" target="_blank">${value}</a>` : value;
            let displayValue;
            if (this.isDate(value)) {
                const date = new Date(value).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
                displayValue = date;
            }
            else if (this.isNumber(value)) {
                displayValue = Math.round(value).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                });
            }
            else {
                displayValue = anchorTag;
            }
            const label = $(`<div class="feature-info-row">${key}: ${displayValue}</div>`);
            labelInfo.append(label);
        });
        labelContent.append(labelInfo);
        tooltipElement.prepend(labelContent);
        return tooltipElement;
    }
    setupPinButton(data) {
        const strap = this.getStrap(data);
        let pinButton = $(`#label-content`).find(`#pin-button-${strap}`);
        if (pinButton.length === 0) {
            $(`#label-content`).prepend(`<button id="pin-button-${strap}"><i class="fas fa-thumbtack fa-xs" title="Pin"></i></button>`);
            pinButton = $(`#pin-button-${strap}`);
        }
        return pinButton;
    }
    handlePinButtonClick(pinButton, data, pinnedTooltips) {
        const strap = this.getStrap(data);
        if (pinnedTooltips.includes(strap)) {
            pinnedTooltips = pinnedTooltips.filter(id => id !== strap);
        }
        else {
            pinnedTooltips.push(strap);
        }
        let isPinned = pinnedTooltips.includes(strap);
        pinButton.html(isPinned ? '<i class="fas fa-thumbtack fa-rotate-90 fa-xs" title="UnPin"></i>' : '<i class="fas fa-thumbtack fa-xs" title="Pin"></i>');
        return pinnedTooltips;
    }
    static removeUnpinnedTooltips(event, pinnedTooltips, map) {
        let allTooltips = $('[id*=tooltip-]');
        if (allTooltips.length > 0) {
            const mouseEvent = event.originalEvent;
            const mouseX = mouseEvent.clientX;
            const mouseY = mouseEvent.clientY;
            allTooltips.each(function () {
                const tooltipRect = this.getBoundingClientRect();
                if (!(mouseX >= tooltipRect.left && mouseX <= tooltipRect.right && mouseY >= tooltipRect.top && mouseY <= tooltipRect.bottom)) {
                    if (pinnedTooltips && !pinnedTooltips.includes(this.id.replace('tooltip-', ''))) {
                        if (map) {
                            const overlayToRemove = map.getOverlays().getArray().find(overlay => { var _a; return ((_a = overlay.getElement()) === null || _a === void 0 ? void 0 : _a.id) === this.id; });
                            if (overlayToRemove) {
                                map.removeOverlay(overlayToRemove);
                            }
                        }
                        $(this).remove();
                    }
                }
            });
        }
    }
    isDate(value) {
        if (typeof value === 'string') {
            const date = moment(value, moment.ISO_8601, true);
            return date.isValid() && date.format() === value;
        }
        return false;
    }
    isNumber(value) {
        return !isNaN(value) && typeof value === 'number';
    }
    getStrap(data) {
        var _a;
        return (_a = data === null || data === void 0 ? void 0 : data.dsp_strap) !== null && _a !== void 0 ? _a : this.feature.get('strap');
    }
}
